import React from 'react';

import './styles.css';
import { useRouter } from '../../providers/Router/RouterProvider';
import { AnimatedBattery } from '../AnimatedBattery/AnimatedBattery';
import { useStats } from './useStats';

export const ActiveSessionScreen = () => {
  const { navigate } = useRouter();

  const handleSignUp = () => navigate('form');

  const { power, duration, cost } = useStats();

  return (
    <div className='container mx-auto max-w-sm'>
      <div className="ActiveSessionScreen h-screen w-full bg-background overflow-hidden relative flex flex-col gap-1 justify-between">
        
        <h1 className="text-2xl font-bold text-primary my-6 text-center">Charging</h1>

        <div className="flex-1 text-center flex flex-col gap-3 justify-between">
          <div>
            <p className="text-sm text-gray-500 mb-1">Device</p>
            <p className="text-3xl font-bold">ON 603</p>
          </div>

          <div className='py-4' style={{ zoom: 0.8 }}>
            <AnimatedBattery />
          </div>

          <div>
            <p className="text-sm text-gray-500 mb-1">Duration</p>
            <p className="text-3xl font-bold">{Math.floor(duration / 60)}:{String(duration % 60).padStart(2, '0')} min</p>
          </div>

          <div>
            <p className="text-sm text-gray-500 mb-1">Power Consumed</p>
            <p className="text-3xl font-bold">{power} kWh</p>
          </div>

          <div>
            <p className="text-sm text-gray-500 mb-1">Cost</p>
            <p className="text-3xl font-bold">${cost}</p>
          </div>
        </div>

        <div className="mt-auto flex justify-center mt-20 mb-8 pt-8 text-center">
          <button className="bg-primary text-white px-6 py-3 rounded-full" onClick={handleSignUp}>
            ENTER TO WIN
          </button>
        </div>

      </div>
    </div>
  );
}